import { Component } from '@angular/core';

@Component({
  selector: 'trending-tab',
  templateUrl: './trending.component.html',
  styleUrls: ['./trending.component.css'],
})
export class TrendingTabComponent {}
